import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';

import { BaseHttpClient, BaseHttpParams } from '@bayclubs/utils';

@Injectable({
    providedIn: 'root'
})
export class ApiHttpClient extends BaseHttpClient {

    constructor(httpClient: HttpClient) {
        super(httpClient);
        console.log('Creating api http client');
    }

    getUrl(): string { return environment.apiBaseUrl; }

    postFormData<T>(url: string, formData: FormData): Observable<T> {
        return this.httpClient.post<T>(this.getUrl() + url, formData, {
            params: new BaseHttpParams(false, null)
        });
    }
}